import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export default function ModalConfirmation({ faccao, isOpen, toggle, removeFavorito, clearPedidos, carregarFavoritos }) {
    return (
        <Modal isOpen={isOpen} toggle={toggle} className='modal-dialog-centered'>
            <ModalHeader toggle={toggle}>Atenção!</ModalHeader>
            <ModalBody>
                Deseja realmente remover a facção {faccao.label} - {faccao.value}?
            </ModalBody>
            <ModalFooter 
                style={{ display: 'flex', justifyContent: 'space-between'}}
            >
                <span
                    style={{ marginRight: '10px', color: '#4dbd74', fontWeight: 'bold', cursor: 'pointer' }}
                    onClick={() => {
                        removeFavorito(faccao.value);
                        clearPedidos();
                        carregarFavoritos();
                        toggle();
                        
                    }}
                >Remover e atualizar dados</span>
                <div>
                    <Button 
                        color='secondary' 
                        onClick={() => toggle()}
                        style={{ marginRight: '10px', background: 'red', borderColor: 'red', color: 'white', fontWeight: 'bold' }}
                    >
                        Não
                    </Button>
                    <Button
                        className='btn btn-succsess'
                        style={{ background: '#4dbd74', borderColor: '#4dbd74', color: 'white', fontWeight: 'bold' }}
                        onClick={() => {
                            removeFavorito(faccao.value);
                            toggle();
                        }}
                    >
                        Remover
                    </Button>
                </div>
                
            </ModalFooter>
        </Modal>
    );
}
